export default {
        application: require('./components/application/dist.index.js').default,
container: require('./components/container/dist.index.js').default,
layout: require('./components/layout/dist.index.js').default,
row: require('./components/row/dist.index.js').default,
flex: require('./components/flex/dist.index.js').default,
AppHeader: require('./components/AppHeader/dist.index.js').default,
text: require('./components/text/dist.index.js').default,
Sidebar: require('./components/Sidebar/dist.index.js').default,
image: require('./components/image/dist.index.js').default,
form: require('./components/form/dist.index.js').default,
input: require('./components/input/dist.index.js').default,
button: require('./components/button/dist.index.js').default,
html: require('./components/html/dist.index.js').default,
link: require('./components/link/dist.index.js').default,
modal: require('./components/modal/dist.index.js').default,
col: require('./components/col/dist.index.js').default,
HomeThumbnails: require('./components/HomeThumbnails/dist.index.js').default,
SetThumbnails: require('./components/SetThumbnails/dist.index.js').default,
BookThumbnails: require('./components/BookThumbnails/dist.index.js').default,
CollectionThumbnails: require('./components/CollectionThumbnails/dist.index.js').default,
PieceHeader: require('./components/PieceHeader/dist.index.js').default,
ContentTabs: require('./components/ContentTabs/dist.index.js').default,
Content: require('./components/Content/dist.index.js').default,
Search: require('./components/Search/dist.index.js').default,
History: require('./components/History/dist.index.js').default,
Bookmarks: require('./components/Bookmarks/dist.index.js').default,
Favourites: require('./components/Favourites/dist.index.js').default,
Students: require('./components/Students/dist.index.js').default,
Metronome: require('./components/Metronome/dist.index.js').default,
Admin: require('./components/Admin/dist.index.js').default,
MyAccount: require('./components/MyAccount/dist.index.js').default
      }